export class SelectOptionMessage {
}